<p class="button-bar">
    <button
        title="Select All"
        pButton
        pRipple
        text
        severity="secondary"
        type="button"
        [disabled]="sending"
        (click)="selectedEmployees = items"
        label="Select All"
    ></button>
    <button
        title="Select None"
        pButton
        pRipple
        text
        severity="secondary"
        type="button"
        [disabled]="sending"
        (click)="selectedEmployees = []"
        label="Select None"
        class="mx-3"
    ></button>
    <button
        title="Send Hours"
        icon="pi pi-send"
        pButton
        pRipple
        severity="primary"
        type="button"
        [disabled]="sending"
        (click)="onSendHours(employeeTree.selection)"
        label="Send Hours"
    ></button>
</p>
<p *ngIf="sending" class="mb-3">
    Sending {{ progress?.current || 0 }} of {{ progress?.total || 0 }}
</p>
<p
    [style.pointer-events]="sending ? 'none' : null"
    [style.opacity]="sending ? '0.6' : null"
>
    <p-tree
        [filter]="true"
        filterMode="strict"
        filterPlaceholder="Search for user"
        #employeeTree
        [value]="items"
        selectionMode="checkbox"
        [(selection)]="selectedEmployees"
        scrollHeight="flex"
    ></p-tree>
</p>

